import { atom } from 'jotai';

export const contactsIntegrationModalOpen = atom(false);
